export const stateKey = 'nodeDefsValidation'
